import angular from 'angular';
import { ConfirmDeleteModal } from '~/utils/modals';
import templateModalDroit from '~/components/droit/modal/modal-droit.html';
import ModalDroitController from '~/components/droit/modal/modal-droit.controller';
import APIV5 from '~/models/api';
import Defaults from '~/scripts/constants/defaults';
// eslint-disable-next-line import/no-cycle
import QueryTab from '~/components/query/query-tab';
import queryHomeList from '~/components/query/query-home/query-home-list.query';
import queryHomeListAdmin from '~/components/query/query-home/query-home-list-admin.query';
import $ from 'jquery';
import { UserModel } from '~/scripts/services/model/user';

/* globals Knitiv */

export default class QueryController {
	/** @type {boolean} */
	#opening;

	/** @type {any} */
	#temporaryFile;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('angular').IWindowService} $window
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {UserModel} User
	 */
	constructor(
		$injector,
		$location,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		$window,
		NodeService,
		Notification,
		User,
	) {
		this.$injector = $injector;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.$window = $window;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		this.active = 0;
		this.config = undefined;
		this.ready = false;
		this.loading = false;
		this.widgetId = '';

		/** @type {any[]} */
		this.queries = [];

		/** @type {QueryTab[]} */
		this.tabs = [];

		this.canCreate = this.$rootScope.context?.role?.mode === 'ADMIN_SUPER'
			|| this.$rootScope.context?.role?.mode === 'ADMIN_SYS'
			|| this.$rootScope.context?.role?.sql_in.includes('K_NODE;KR_QUERY');

		// -------------- Private vars --------------
		this.#opening = false;
		this.#temporaryFile = undefined;

		// -------------- Events --------------
		this.$scope.$on('angular-resizable.resizeEnd', (/** @type {any} */ event, /** @type {any} */ info) => {
			if (info.width === false) {
				if (info.height <= 20) {
					angular.element('.tab-interface .tab-pane.active .query-editor').css('flex-basis', 0);
					this.tabs[this.active].edit = false;
				}
				else if (!this.tabs[this.active].edit) {
					this.tabs[this.active].edit = true;
				}
			}
		});

		this.$scope.$on('$viewContentLoaded', () => {
			angular.element('html').css('overflow', 'hidden');
		});

		this.$scope.$on('Query.refreshList', () => this.homeListQueries(this.$location.path() === '/query'));

		this.$scope.$on('$destroy', async () => {
			await this.init();
			angular.element('html').css('overflow', '');
		});

		// -------------- Main --------------
		this.isOpen = false;
		(async () => {
			await this.init();
			if (this.$location.path() === '/query') {
				this.config = () => Defaults.query;
				// @ts-ignore
				this.$rootScope.$on('$translateChangeSuccess', () => {
					this.tabs[0].name = this.$translate.instant('common.home');
				});
				await this.openFromURL();
				this.$scope.$on('$locationChangeSuccess', () => this.openFromURL());
			}
			else {
				await this.homeListQueries(false);
			}
		})();
	}

	refreshSize() {
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}

	/**
	 * @param {boolean} state
	 */
	onToggle(state) {
		this.state = state;
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}

	/**
	 * @param {Event} event
	 * @param {number} index
	 */
	async close(event, index) {
		event.preventDefault();
		if (index > 0) {
			await this.tabs[index]?.close();
			this.$timeout(() => {
				if (this.active >= index && (this.active - 1 in this.tabs) && this.active - 1 !== index) {
					this.active--;
				}
				this.tabs.splice(index, 1);
			});
		}
	}

	/**
	 * @param {any} event
	 * @param {any} query
	 * @returns {Promise<any>}
	 */
	async confirmDeleteQuery(event, query) {
		event.preventDefault();
		const modal = new ConfirmDeleteModal(this.$injector);
		const answer = await modal.open(query.node?.getName() || query.name);

		if (answer) {
			try {
				await this.NodeService.delete(query.node?.kid || query.kid);
				return this.homeListQueries(this.$location.path() === '/query');
			}
			catch (error) {
				console.error(error);
				angular.element(event.target).closest('.list-group-item').trigger('blur');
			}
		}
		return false;
	}

	/**
	 * @param {boolean} fromQueryPage
	 */
	async homeListQueries(fromQueryPage) {
		this.loading = true;
		this.queries.length = 0;

		const isAdmin = this.User?.getProfil()?.admin ?? false;

		const response = await APIV5.instance.queryExec({
			query: (isAdmin && fromQueryPage) ? queryHomeListAdmin : queryHomeList,
			packet_size: 500,
		}, { id: 'query.home-list-queries' });
		this.queries = response.result.rows;
		this.ready = true;
		this.loading = false;
		if (!this.$rootScope.$$phase) {
			this.$scope.$digest();
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
		}
	}

	/**
	 * @param {File[]} files
	 */
	import(files) {
		if (this.active) {
			this.tabs[this.active].import(files[0]);
		}
		else {
			this.#temporaryFile = files[0];
			this.newQuery();
		}
	}

	async init() {
		this.tabs.length = 0;
		if (this.canCreate) {
			this.tabs.push(
				{
					id: 'home',
					// @ts-ignore
					node: { kid: 'home' },
					name: this.$translate.instant('common.home'),
				},
			);
		}
		return this.NodeService.load('K_NODE;KSYSQUERY', ['droit'], ['ALL']);
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {any} item
	 * @returns {boolean}
	 */
	isDeletable(item) {
		return (item.kright & Defaults.DROIT.DELETE) > 0;
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {any} item
	 * @returns {boolean}
	 */
	isEditable(item) {
		return (item.kright & Defaults.DROIT.MODIFY) > 0;
	}

	newQuery() {
		this.$location.path('/query').search({ create: true, edit: true, kid: `K_NODE;${this.User.getRef()}` });
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode | 'home'} queryId
	 * @param {boolean} edit
	 * @param {boolean} create
	 * @param {boolean} duplicate
	 */
	async open(queryId, edit, create, duplicate) {
		if (this.#opening || !('tabs' in this)) {
			return;
		}

		if (queryId === 'home') {
			this.active = 0;
		}
		else {
			let isOpen = false;
			// search in tabs if one is opened (skip when duplicating: the copy must always open a new tab)
			if (!duplicate) {
				for (const [k, tab] of this.tabs.entries()) {
					if (tab.node?.kid === queryId) {
						this.$timeout(() => {
							this.active = k;
						});
						isOpen = true;
					}
				}
			}

			try {
				if (!isOpen) {
					if (create) {
						const newTab = new QueryTab(this.$injector);
						await newTab.createTab(queryId);
						this.tabs.push(newTab);

						this.$timeout(async () => {
							if (this.#temporaryFile) {
								this.tabs[1].import(this.#temporaryFile);
								this.$timeout(() => {
									this.#temporaryFile = null;
								});
							}
							this.$timeout(() => {
								this.active = this.tabs.length - 1;
							});
						});
					}
					else {
						this.#opening = true;
						const newTab = new QueryTab(this.$injector);
						await newTab.load(queryId, edit, duplicate);
						this.tabs.push(newTab);
						// this.tabs.splice(1, 0, newTab);
						// const homeTab = this.tabs.shift();
						// this.tabs.unshift(homeTab, newTab);
						this.#opening = false;
						this.$timeout(() => {
							this.$timeout(() => {
								// this.active = 1;
								this.active = this.tabs.length - 1;
							});
						});
					}
				}
			}
			catch (error) {
				console.error(error);
				this.#opening = false;
			}
		}
	}

	async openFromURL() {
		const search = this.$location.search();
		if ('kid' in search) {
			await this.open(
				search.kid,
				'edit' in search,
				'create' in search,
				'duplicate' in search,
			);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	openQueryFromFile() {
		$('#input-file-hidden').find('input[type="file"]').trigger('click');
	}

	/**
	 * @param {any} query
	 */
	async queryEditDroits(query) {
		const node = await this.NodeService.load(query.kid);
		query.node = node;

		query.node = await this.$uibModal.open({
			ariaLabelledBy:  'modal-droit-title',
			ariaDescribedBy: 'modal-droit-body',
			template:        templateModalDroit,
			controller:      ModalDroitController,
			controllerAs:    '$ctrl',
			resolve:         {
				node: () => node,
				edit: true,
			},
		}).result;

		await this.NodeService.update(query.node);
		this.Notification.info({
			title:   this.$translate.instant('common.info'),
			message: this.$translate.instant('search.bookmark-updated'),
		});
	}

	/**
	 * @param {Event} event
	 */
	toggle(event) {
		event.stopPropagation();
		this.isOpen = !this.isOpen;
	}

	/**
	 * @param {QueryTab} tab
	 */
	updatePath(tab) {
		if (!tab.node.kid || this.#opening || !('tabs' in this) || !this.ready) {
			return;
		}

		// @ts-ignore
		if (tab.node.kid === 'home') {
			this.$location.search({
				create: null,
				edit:   null,
				kid:    null,
			});
			this.$rootScope.title = 'menu.query';
		}
		else {
			this.$location.search({
				create: tab.create || null,
				edit:   tab.edit || null,
				kid:    tab.node.kid,
			});
			this.$rootScope.title = `${tab.node.getName()} - ${this.$translate.instant('menu.query')}`;
		}
	}
}
